/* eslint-disable array-callback-return */
import validator from "validator";
import { breathworkPageData as pageData } from "../utils/pageContent";

function AddEditBreathworkVali(data, expertId, selectedCategory, audios) {
  const errors = {};
  const validationMessages = pageData.addEditBreathworkPageData.validationMessages;

  if (validator.isEmpty(data.breathworkTitle.trim()))
    errors.breathworkTitle = validationMessages.enterNameErrorMessage;
  if (selectedCategory?.length === 0 && !data.breathworkId)
    errors.focus = validationMessages.selectCategoryErrorMessage;
  if (validator.isEmpty(data.description.trim()))
    errors.description = validationMessages.enterDescriptionErrorMessage;
  if (audios?.length === 0) {
    errors.audios = validationMessages.selectAudioErrorMessage;
  } else {
    audios?.map((audio, index) => {
      if (!audio?.audio && audio?.audio === "" && audio?.file !== File)
        errors["audio" + index] = validationMessages.selectFileErrorMessage;
      if (audio?.language === "")
        errors["language" + index] = validationMessages.selectLanguageErrorMessage;
    });
  }
  // if (!selectedFile && selectedFile === '' && selectedFile !== File)
  //   errors.breathworkFile = 'Please select the file.';
  if (!expertId?.id) errors.expertId = validationMessages.selectExpertErrorMessage;
  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddEditBreathworkVali;
